export default __webpack_public_path__ + "static/media/construction_machinery.7bcbfb06.png";